<template>
  <div>
    <v-card dark>
      <v-card-title>
        <h2>Gallery</h2>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.stop="selectImagesDialog = true">Select Images</v-btn>
      </v-card-title>
      <template v-if="loading">
        <v-container>
          <v-progress-linear :size="70" :width="7" color="primary" indeterminate>
          </v-progress-linear>
        </v-container>
      </template>
      <v-container>
        <v-card light>
          <v-layout>
            <v-flex>
              <template v-for="i in galleryImages">
                <div :key="i.id" class="picture-container" style="display:inline;">
                  <img :key="i.id" :src="i.downloadUrl" width="auto" />
                  <button @click="removeImage(i)" class="btn-remove">Remove</button>
                </div>
              </template>
            </v-flex>
          </v-layout>
        </v-card>
      </v-container>
    </v-card>

    <v-dialog v-model="selectImagesDialog" max-width="700px">
      <v-card>
        <v-card-title>
          <h3>Select Images</h3>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-layout column>
              <v-flex>
                <v-btn raised color="primary" @click="onPickFiles">Select Images</v-btn>
                <input type="file" style="display:none;" ref="fileInput" accept="image/*" multiple @change="onFilesPicked" />
              </v-flex>
              <v-flex>
                <v-layout row>
                  <v-flex>
                    <v-card style="margin:6px;8px;">
                      <v-card-title>
                        <h3>Selected Images</h3>
                      </v-card-title>
                      <v-card-text>
                        <v-layout row>
                          <v-flex id="previewSection">

                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat v-on:click="closeSelectImagesDialog">Close</v-btn>
          <v-btn color="success" v-on:click="uploadImages" :disabled="!isComplete">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
  .picture-container {
    position: relative;
    max-height: 250px;
    width: 200px;
  }

  .picture-container img {
    height: 250px;
    padding: 3px;
    margin: 5px;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.6);
    border-radius: 3px;
  }

  .picture-container .btn-remove {
    position: absolute;
    top: 0%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    cursor: pointer;
    display: none;
    color: white;
    font-size: 14px;
    background-color: rgb(248, 70, 70);
    padding: 3px;
    border-radius: 3px;
  }

  .picture-container:hover .btn-remove {
    display: block;
  }

  .picture-container:hover i {
    color: rgba(0, 0, 0, 0.8);
  }

</style>


<script>
  import {
    mapGetters,
    mapActions
  } from "vuex";
  import Image from "../../../store/models/Image.js";

  export default {
    data() {
      return {
        selectImagesDialog: false,
        images: []
      };
    },
    computed: {
      ...mapGetters({
        loading: "getLoading",
        galleryImages: "getImages"
      }),
      isComplete() {
        return this.images.length > 0;
      }
    },
    methods: {
      onPickFiles() {
        this.$refs.fileInput.click();
      },
      onFilesPicked(event) {
        this.images = [];
        this.newImageUrls = [];

        const files = event.target.files;

        let div = document.getElementById("previewSection");
        div.innerHTML = "";
        for (let i = 0; i < files.length; i++) {
          let file = files[i];

          const fileReader = new FileReader();
          fileReader.addEventListener("load", event => {
            var picFile = event.target;
            div.innerHTML +=
              "<img src='" + fileReader.result + "' height='150px' />";
          });
          fileReader.readAsDataURL(file);
        }
        this.images = files;
      },
      uploadImages() {
        this.$store.dispatch("uploadImages", this.images);

        this.closeSelectImagesDialog();
      },
      removeImage(toRemove) {
        this.$store.dispatch("removeImage", toRemove);
      },
      closeSelectImagesDialog() {
        let div = document.getElementById("previewSection");
        div.innerHTML = "";
        this.images = [];
        this.selectImagesDialog = false;
      }
    },
    created: function () {
      this.$store.dispatch("getAllImages");
    }
  };

</script>
